<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Import </span> /
      <span> Confirm </span>
    </nav>
    <import-steps></import-steps>

    <div class="container">
      <h2 class="flow-heading mt-5">Final details before you complete your import</h2>

      <flow-confirm-details header="CRM Import" :details="details" :timezone="timezone"></flow-confirm-details>

      <flow-conditions
        :platformTitle="platformTitle"
        heading="Before importing, please read and attest to the following:"
        @read="readingFinished = true"
      ></flow-conditions>
      <form :action="`/import/progress/${searchParams}`" method="POST" class="text-center">
        <input type="hidden" name="selectedGroupsIds" :value="selectedGroupsIds" />
        <div>
          <a class="btn btn-lg btn-outline-primary mr-2" href="/import/select-groups/">Back</a>
          <button type="submit" class="btn btn-lg btn-primary" :disabled="!readingFinished">Finalize Import</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ImportSteps from '../components/import/ImportSteps';
import dateFormatter from '../mixins/dateFormatter';
import FlowConfirmDetails from '../components/shared/FlowConfirmDetails';
import FlowConditions from '../components/shared/FlowConditions';
import {getCommercialName} from '../utility/crms/getCommercialName.js';

export default {
  name: 'import-confirm-page',
  mixins: [dateFormatter],
  components: {ImportSteps, FlowConfirmDetails, FlowConditions},
  data() {
    return {
      readingFinished: false,
    };
  },
  props: {
    vessel: {
      type: String,
      required: true,
    },
    selectedGroupsIds: {
      type: String,
      required: true,
    },
    selectedGroups: {
      type: String,
      required: true,
    },
    crm: {
      type: String,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    platformTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    vesselName() {
      return JSON.parse(this.vessel).name;
    },
    groups() {
      return JSON.parse(this.selectedGroups);
    },
    details() {
      return [
        {name: 'Imported From', content: `${this.crmName} CRM`},
        {name: `${this.crmName} Groups`, groups: this.groups},
      ];
    },
    crmName() {
      return getCommercialName(JSON.parse(this.crm).crm_name);
    },
    searchParams() {
      return window.location.search;
    },
  },
  methods: {
    onScroll(e) {
      if (e.target.scrollTop + e.target.clientHeight + 1 >= e.target.scrollHeight) {
        this.readingFinished = true;
      }
    },
  },
};
</script>
